import { Box, Popover, PopoverContent, PopoverTrigger, useDisclosure } from '@chakra-ui/react'

import EmojiPicker from '@/components/EmojiPicker/EmojiPicker'

export default function ReactionButton({
  onReact,
  onOpen,
  onClose,
  buttonComponent,
  disabled = false,
}: {
  onReact: (reaction: string) => Promise<void>
  onOpen?: () => void
  onClose?: () => void
  buttonComponent: (params: { active: boolean; disabled: boolean }) => JSX.Element
  disabled?: boolean
}): JSX.Element {
  const { isOpen, onClose: onClosePopover, onOpen: onOpenPopover } = useDisclosure()

  return disabled ? (
    buttonComponent({ active: isOpen, disabled })
  ) : (
    <Popover
      isOpen={isOpen}
      onClose={() => {
        onClosePopover()
        onClose?.()
      }}
      onOpen={() => {
        onOpenPopover()
        onOpen?.()
      }}
      strategy="fixed"
    >
      <PopoverTrigger>
        <Box>{buttonComponent({ active: isOpen, disabled })}</Box>
      </PopoverTrigger>
      <PopoverContent>
        <EmojiPicker onSelect={onReact} />
      </PopoverContent>
    </Popover>
  )
}
